import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import Grid from '@mui/material/Grid'
import Box from '@mui/material/Box'
import SelectField from '@/v2/components/common/SelectField'
import { useInsurances } from '@/v2/hooks/insurance/useInsurances'
import Subscriber from './subforms/Subscriber'

const Form = ({
  isEdit = false,
  values = {},
  error = {},
  onChange,
  patient,
  eligibility,
}) => {
  const { id } = useParams()
  const { insurances } = useInsurances(id)
  const insuranceOptions = (insurances = []) =>
    insurances.map(insurance => ({
      value: insurance.id,
      label: insurance.payer.name,
    }))
  const handleChangeInsurance = value => {
    const insurance = insurances.find(({ id }) => `${id}` === value)
    onChange({
      insuranceId: value,
      subscriber: {
        relationship: insurance?.relationship || '',
      },
    })
  }

  const handleChangeSubscriber = value => onChange({ subscriber: value })

  useEffect(() => {
    if (!insurances?.length) return
    if (insurances.length === 1 || !values.insuranceId) {
      const [insurance] = insurances
      onChange({
        insuranceId: insurance.id,
        subscriber: {
          relationship: insurance.relationship || '',
        },
      })
    }
  }, [insurances])

  return (
    <Box sx={{ width: '100%', overflowX: 'hidden' }}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={isEdit ? 6 : 8}>
          <SelectField
            fullWidth
            noMargin
            label="Insurance"
            name="insurance"
            placeholder="Choose an option"
            options={insuranceOptions(insurances)}
            value={values.insuranceId}
            error={error?.insuranceId}
            onChange={handleChangeInsurance}
            disabled={isEdit || insurances?.length === 1}
          />
        </Grid>

        {values?.insuranceId && (
          <Subscriber
            patient={patient}
            patientId={id}
            editAllowed={true}
            isEdit={isEdit}
            values={values}
            error={error}
            onChange={handleChangeSubscriber}
            eligibility={eligibility}
          />
        )}
      </Grid>
    </Box>
  )
}

export default Form
